/**
 * Danh mục 11 dịch vụ (V2 gieo 11, V44 bỏ Nhật ký truy vết — ADR-UI-0017, migration sau thêm Biên bản cuộc họp — ADR-0126), ánh xạ từ nhóm điều hướng của Portal (ADR-0019 §2.1).
 *
 * **Vì sao giao diện giữ một bản hằng số thay vì chỉ đọc API.** Cổng tenant phải
 * biết đường dẫn nào thuộc dịch vụ nào **ngay lúc dựng khung** — `useNguCanhCuaToi`
 * tính quyền điều hướng đồng bộ, trước khi có cơ hội chờ một lời gọi mạng. Đọc
 * `GET /api/v1/dich-vu` ở đó sẽ làm thanh điều hướng nhảy sau mỗi lần tải.
 *
 * Danh mục chỉ đổi khi deploy (thêm một dịch vụ đòi thêm nhóm điều hướng, mã module
 * ở Gateway, và một migration), nên một bản hằng số là đúng bản chất của nó.
 *
 * **Bản này phải khớp ba nơi khác**, và có test canh từng nơi:
 *
 * 1. `docs/goi-dich-vu/fixture-chuan.json` — nguồn số liệu dùng chung với bản Java
 *    (ADR-0050). `danh-muc.test.ts` so tệp này với tệp đó.
 * 2. Seed của `db/control-plane/migrations/V2__goi_dich_vu.sql` và migration thêm dịch vụ về sau.
 * 3. Trường `dichVu` của từng nhóm ở `components/layout/nav-config.ts`.
 *
 * Sửa một nơi thì sửa cả bốn. Đừng sửa riêng tệp này cho test xanh.
 */
import type { DichVu } from './types.ts';

export const DANH_MUC: readonly DichVu[] = [
  { ma: 'tong-quan', ten: 'Tổng quan', mo_ta: '', thu_tu: 1, bat_buoc: true, vung_api: [] },
  { ma: 'cau-hinh-he-thong', ten: 'Cấu hình hệ thống', mo_ta: '', thu_tu: 2, bat_buoc: true, vung_api: [] },
  { ma: 'tri-thuc-ai', ten: 'Tri thức AI', mo_ta: '', thu_tu: 3, bat_buoc: false, vung_api: ['tri-thuc'] },
  { ma: 'xu-ly-tai-lieu', ten: 'Xử lý tài liệu', mo_ta: '', thu_tu: 4, bat_buoc: false, vung_api: ['ocr'] },
  { ma: 'xu-ly-van-ban', ten: 'Xử lý văn bản', mo_ta: '', thu_tu: 5, bat_buoc: false, vung_api: ['van-ban', 'nhiem-vu'] },
  { ma: 'tro-ly-ai', ten: 'Trợ lý AI', mo_ta: '', thu_tu: 6, bat_buoc: false, vung_api: ['tro-ly-ai', 'tri-thuc'] },
  { ma: 'tham-dinh-ai', ten: 'Thẩm định AI', mo_ta: '', thu_tu: 7, bat_buoc: false, vung_api: ['tham-dinh'] },
  { ma: 'dinh-danh-ekyc', ten: 'Định danh eKYC', mo_ta: '', thu_tu: 8, bat_buoc: false, vung_api: ['ekyc'] },
  { ma: 'bao-cao-doanh-nghiep', ten: 'Báo cáo doanh nghiệp', mo_ta: '', thu_tu: 9, bat_buoc: false, vung_api: ['bao-cao'] },
  { ma: 'quan-ly-rpa', ten: 'Quản lý RPA', mo_ta: '', thu_tu: 10, bat_buoc: false, vung_api: ['rpa'] },
  { ma: 'bien-ban', ten: 'Biên bản cuộc họp', mo_ta: '', thu_tu: 11, bat_buoc: false, vung_api: ['bien-ban'] },
];
